import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const HowYouCanHelp = () => {
    return (
        <div className="p-3 p-md-5 bg-light min-vh-100">
            <div className="container">
                {/* Header Section: Quote */}
                <div
                    className="text-center mb-4 mb-md-5 animate__animated animate__fadeIn py-4 py-md-5 rounded-lg shadow-lg"
                    style={{
                        background: 'linear-gradient(135deg, #28a745, #218838)',
                        color: '#fff',
                        marginTop: '10px',
                    }}
                >
                    <blockquote className="blockquote mb-0" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                        <p>“Truly, I say to you, As you did it to one of the least of these my brothers you did it to me.”</p>
                        <footer className="blockquote-footer text-white">Matthew 25:40</footer>
                    </blockquote>
                </div>

                {/* Support Our Mission Section */}
                <div className="mb-4 mb-md-5 animate__animated animate__fadeIn">
                    <h2
                        className="text-center mb-3 mb-md-4 fw-bold text-dark"
                        style={{
                            fontSize: '2rem',
                            letterSpacing: '0.5px',
                            borderBottom: '3px solid #28a745',
                            paddingBottom: '8px',
                            textAlign: 'center',
                            fontFamily: 'Georgia'
                        }}
                    >
                        Support Our Mission
                    </h2>
                    <p className="text-center text-muted mb-3 mb-md-4" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                        Be a part by contributing:
                    </p>
                    <div className="d-flex flex-column flex-md-row justify-content-center gap-2 gap-md-4 mb-3 mb-md-4">
                        <div className="d-flex align-items-center justify-content-center">
                            <span className="text-success me-2" style={{ fontSize: '1.2rem' }}>★</span>
                            <span className="text-muted" style={{ fontSize: '0.9rem' }}>Contributing your time</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <span className="text-success me-2" style={{ fontSize: '1.2rem' }}>★</span>
                            <span className="text-muted" style={{ fontSize: '0.9rem' }}>Contributing your money</span>
                        </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-center gap-2 gap-md-3 w-100">
                        <Link
                            to="/contact-us"
                            style={{ textDecoration: 'none', display: 'inline-block', width: '100%', maxWidth: '200px' }}
                            className="mx-auto mx-md-0"
                        >
                            <button
                                className="btn btn-success text-uppercase w-100"
                                style={{
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    fontSize: '0.9rem',
                                    border: 'none',
                                    cursor: 'pointer',
                                    boxShadow: 'none'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#218838';
                                    e.target.style.transform = 'scale(1.05)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#28a745';
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                Donate Now
                            </button>
                        </Link>
                        <Link
                            to="/volunteers"
                            style={{ textDecoration: 'none', display: 'inline-block', width: '100%', maxWidth: '200px' }}
                            className="mx-auto mx-md-0"
                        >
                            <button
                                className="btn btn-outline-secondary text-uppercase w-100"
                                style={{
                                    borderRadius: '8px',
                                    padding: '10px 20px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    fontSize: '0.9rem',
                                    borderColor: '#6c757d',
                                    cursor: 'pointer',
                                    boxShadow: 'none',
                                    backgroundColor: 'transparent',
                                    color: '#6c757d'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#6c757d';
                                    e.target.style.color = '#fff';
                                    e.target.style.transform = 'scale(1.05)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.color = '#6c757d';
                                    e.target.style.transform = 'scale(1)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            >
                                Volunteer
                            </button>
                        </Link>
                    </div>
                </div>

                {/* Row 1: Sections 1 to 3 */}
                <div className="row mb-4 mb-md-5 animate__animated animate__fadeIn">
                    {/* Section 1: Services */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    1. Services
                                </h3>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">To maintain inmate hygiene</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">To maintain homes</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">To care for inmates</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: Professional Services */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    2. Professional Services
                                </h3>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">Doctors, nurses, hair dressers, self-employment trainers, teachers, counselors</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">Engineers, cooks, carpenters, plumbers, masons</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: Volunteers */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    3. Volunteers
                                </h3>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">For bills – electricity, water, telephone, etc.</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">For medical chargers</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">For food, clothing, etc.</li>
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">For home maintenance and repairs</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Row 2: Sections 4 to 6 */}
                <div className="row mb-4 mb-md-5 animate__animated animate__fadeIn">
                    {/* Section 4: Personal Effects */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    4. Personal Effects
                                </h3>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">Diapers, tooth brushes, shaving kits, sanitary equipment, etc.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Section 5: Food */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    5. Food
                                </h3>
                                <p className="text-muted" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                    We always welcome donations of food items to help feed our inmates.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Section 6: Medicine & Medical Equipment */}
                    <div className="col-12 col-md-4 mb-3 mb-md-4">
                        <div
                            className="card border-0 shadow-lg rounded-lg h-100"
                            style={{
                                backgroundColor: '#f8f9fa',
                                borderLeft: '5px solid #28a745',
                                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.03)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                e.currentTarget.style.backgroundColor = '#e9ecef';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                        >
                            <div className="card-body p-3 p-md-4">
                                <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.2rem' }}>
                                    6. Medicine & Medical Equipment
                                </h3>
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item bg-transparent text-muted py-1 py-md-2">Wheelchairs, surgical gloves, medicine, special medical equipment</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 7: Other (Centered) */}
                <div className="mb-4 mb-md-5 animate__animated animate__fadeIn">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div
                                className="card border-0 shadow-lg rounded-lg"
                                style={{
                                    backgroundColor: '#f8f9fa',
                                    borderLeft: '5px solid #28a745',
                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.03)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                                    e.currentTarget.style.backgroundColor = '#e9ecef';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                    e.currentTarget.style.backgroundColor = '#f8f9fa';
                                }}
                            >
                                <div className="card-body p-4 p-md-5">
                                    <h3 className="fw-bold text-dark mb-2 mb-md-3" style={{ fontSize: '1.4rem' }}>
                                        7. Other
                                    </h3>
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item bg-transparent text-muted py-1 py-md-2">Bulbs, plumbing, mattresses, mosquito nets, buckets, cooking tools, cleaning tools</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowYouCanHelp;